import { render, staticRenderFns } from "./_base-process-report-multi-document.vue?vue&type=template&id=8688041a&scoped=true&"
import script from "./_base-process-report-multi-document.vue?vue&type=script&lang=js&"
export * from "./_base-process-report-multi-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8688041a",
  null
  
)

export default component.exports